import { FileText, ClipboardList, X, ExternalLink } from 'lucide-react';

export default function LinkedItemsBadges({
  linkedDocumentIds = [],
  linkedPolicyIds = [],
  documents = [],
  policies = [],
  onRemoveDocument,
  onRemovePolicy,
  readOnly = false
}) {
  const linkedDocs = linkedDocumentIds
    .map(id => documents.find(d => d.id === id))
    .filter(Boolean);

  const linkedPolicies = linkedPolicyIds
    .map(id => policies.find(p => p.id === id))
    .filter(Boolean);

  if (linkedDocs.length === 0 && linkedPolicies.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {linkedDocs.map(doc => (
        <a
          key={doc.id}
          href={doc.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-2 py-1 text-xs bg-blue-500/10 text-blue-400 rounded-md hover:bg-blue-500/20 transition-colors group"
          onClick={(e) => e.stopPropagation()}
        >
          <FileText size={12} />
          <span className="max-w-[120px] truncate">{doc.name}</span>
          <ExternalLink size={10} className="opacity-50 group-hover:opacity-100" />
          {!readOnly && onRemoveDocument && (
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRemoveDocument(doc.id);
              }}
              className="ml-0.5 p-0.5 rounded hover:bg-blue-500/30 transition-colors"
            >
              <X size={10} />
            </button>
          )}
        </a>
      ))}

      {linkedPolicies.map(policy => (
        <a
          key={policy.id}
          href={policy.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-2 py-1 text-xs bg-purple-500/10 text-purple-400 rounded-md hover:bg-purple-500/20 transition-colors group"
          onClick={(e) => e.stopPropagation()}
        >
          <ClipboardList size={12} />
          <span className="max-w-[120px] truncate">{policy.name}</span>
          <ExternalLink size={10} className="opacity-50 group-hover:opacity-100" />
          {!readOnly && onRemovePolicy && (
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRemovePolicy(policy.id);
              }}
              className="ml-0.5 p-0.5 rounded hover:bg-purple-500/30 transition-colors"
            >
              <X size={10} />
            </button>
          )}
        </a>
      ))}
    </div>
  );
}
